'use client';
import React, { useEffect, useState } from 'react';
import './Index.css';
import {
  Box,
  Button,
  IconButton,
  Paper,
  Stack,
  Typography,
  SortDirection,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import Constants from '../../utils/constants';
import HttpService from '../../services/HttpService';
import { useStore } from '../../utils/store';
import CustomPaginationActionsTable from '../../components/TablePagination';
import StatusRequestData from '../../Models/StatusRequest';
import { useNavigate } from 'react-router-dom';

import { useSearch } from '../../components/searchContext';
import AlertMessageComponent from '../../components/AlertMessageComponent';
import { useAlert } from '../../components/alertContext';

import PopOverMenuComponent from '../../components/PopOverMenuComponent';
import ButtonComponent from '../../components/form/ButtonComponent';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import SelectFieldComponent from '../../components/form/SelectFieldComponent';
import SimpleDialogComponent from '../../components/SimpleDialogComponent';
import CommonForm from '../../components/form/CommonForm';
import FormFieldData from '../../Models/FormFieldData';
import TextFieldComponent from '../../components/form/TextFieldComponent';
import NoActionTable from '../../components/NoActionTable';
const WareHouseOnSite: React.FC = () => {
  const { getAdmin } = useStore();
  const { searchQuery } = useSearch();
  const moreIconMenuItems = [
    { label: 'View History', type: 'detail' },
    { label: 'Edit / Adjust', type: 'edit' },
  ];
  const navigate = useNavigate();
  const [form, setForm] = useState<any>({
    inventoryItemLocationId: { required: true, value: '' },

    itemQuantity: { required: true, value: '' },
    reasonId: { required: true, value: '' },
    transactionNote: { required: false, value: '' },
  });
  // Table Columns Definition
  const columns: any[] = [
    {
      field: 'name',
      headerName: 'Name',
      renderCell: (value: any, row: any) => (
        <Box>
          <IconButton
            aria-label="more"
            onClick={() => {
              const selectedIndex = rows.findIndex(
                (item: any) => item.resourceId === row.resourceId
              );
              if (moreOpen === selectedIndex) {
                setMoreOpen(-1);
              } else {
                setMoreOpen(selectedIndex);
              }
            }}
          >
            {moreOpen ===
            rows.findIndex(
              (item: any) => item.resourceId === row.resourceId
            ) ? (
              <KeyboardArrowUpIcon />
            ) : (
              <KeyboardArrowDownIcon />
            )}
          </IconButton>
          {value}
        </Box>
      ),
    },
    {
      field: 'unitType',
      headerName: 'Unit of Measure',
      renderCell: (value: any) => <Box>{value.unitName}</Box>,
    },

    {
      field: 'stockLevel',
      headerName: 'Stock Level',
    },

    {
      field: 'id',
      headerName: '',
      disableSort: true,
      renderCell: (value: any, row: any) => (
        <PopOverMenuComponent
          handleMenuClick={(type) => {
            handleMoreMenu(type, row);
          }}
          menuItems={moreIconMenuItems}
        />
      ),
    },
  ];
  const transferColumns: any[] = [
    {
      field: 'id',
      headerName: 'Resource Item',
      renderCell: (value: any, row: any) => <Box>{row.name}</Box>,
    },
    {
      field: 'stockLevel',
      headerName: 'Qty From Source',
    },
    {
      field: 'quantityOrdered',
      headerName: 'Qty to Transfer',
      renderCell: (value: any, row: any) => (
        <Box sx={{ width: 100 }}>
          <TextFieldComponent
            errorStr=""
            type="text"
            isRequired={false}
            keyName={row.resourceId + '_transferQty'}
            label=""
            name={row.resourceId + '_transferQty'}
            value={value ?? ''}
            onChange={(event: any) => {
              const intOnly = String(event.target.value).replace(/\D/g, '');
              const currentIndex = transferList.findIndex(
                (item) => item.resourceId === row.resourceId
              );
              setTransferList((prevItems) => {
                const updatedItems = [...prevItems];
                if (currentIndex !== -1) {
                  updatedItems[currentIndex]['quantityOrdered'] = intOnly;
                }
                return updatedItems;
              });
            }}
          />
        </Box>
      ),
    },
  ];

  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [totalRecords, setTotalRecords] = useState(0);
  const [saveInProgress, setSaveInProgress] = useState<boolean>(false);
  const [locationList, setLocationList] = useState<any[]>([]);
  const [destinationList, setDestinationList] = useState<any[]>([]);
  const [currentLocation, setCurrentLocation] = useState<any>(0);
  const [currentDestination, setCurrentDestination] = useState<any>(0);
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const [filterList, setFilterList] = useState<any[]>([]);
  const [adjustLocationList, setAdjustLocationList] = useState<any[]>([]);
  const [reasonsList, setReasonsList] = useState<any[]>([]);

  const [currentSelection, setCurrentSelection] = useState('');
  const [transferDialogViewOpen, setTransferDialogViewOpen] =
    useState<boolean>(false);
  const [confirmDailogOpen, setConfirmDailogOpen] = useState<boolean>(false);

  const [adjustDialogViewOpen, setAdjustDialogViewOpen] =
    useState<boolean>(false);
  const [moreOpen, setMoreOpen] = useState<number>(-1);
  const [currentChecked, setCurrentChecked] = useState<any[]>([]);
  const [rows, setRows] = useState<any[]>([]);
  const [transferList, setTransferList] = useState<any[]>([]);
  const [paginate, setPaginate] = useState({
    limit: Constants.DEFAULT_PAGE_SIZE,
    offset: 0,
  });
  const [orderBy, setOrderBy] = useState<any>('id');
  const [order, setOrder] = useState<SortDirection>('asc');
  const handleOrderBy = (orderByColumn: any) => {
    setOrderBy(orderByColumn);
    // console.log(order);
    // console.log(orderByColumn);
    if (order === 'desc') {
      setOrder('asc');
      return;
    } else {
      setOrder('desc');
      return;
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    fetchInventory();
  }, [currentSelection, paginate, searchQuery]);

  const handleMoreMenu = (type: any, row: any) => {
    if (type === 'detail') {
      navigate(`/inventory/warehouse-onsite-inventory/${row.resourceId}`);
    } else {
      setCurrentRecord(row);
      setForm({
        inventoryItemLocationId: { required: true, value: currentLocation },

        itemQuantity: { required: true, value: 0 },
        reasonId: { required: true, value: '' },
        transactionNote: { required: false, value: '' },
      });
      setAdjustDialogViewOpen(true);
      const locationDataList: any = [
        ...row.stockLocations.map((item: any) => ({
          id: item.inventoryItemLocationId,
          label: item.locationName,
          locationType: item.locationType,
        })),
      ];
      setAdjustLocationList(
        locationDataList.sort((a: any, b: any) =>
          a.label.localeCompare(b.label)
        )
      );
    }
  };
  // Fetch Data
  const fetchData = async () => {
    try {
      await fetchLocations();
      if (destinationList.length === 0) await fetchDestinations();
      if (reasonsList.length === 0) await fetchBundleData();
    } catch (error: any) {}
  };
  const handleInputChange = (e: React.ChangeEvent<any>) => {
    const { name, value } = e.target;
    if (name === 'inventoryItemLocationId') {
      const locateIndex = adjustLocationList.findIndex(
        (item: any) => item.inventoryItemLocationId === value
      );
      if (locateIndex !== -1) {
        setForm((prevData: any) => ({
          ...prevData,
          ['stockLevel']: { value: adjustLocationList[locateIndex].stockLevel },
        }));
      }
    }
    setForm((prevData: any) => ({
      ...prevData,
      [name]: { ...prevData[name], value: value },
    }));
  };
  const fetchLocations = async () => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL + Constants.inventoryURL}/locations/source`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        { search: '', limit: -1, offset: 0, isActive: true }
      );
      //console.log(response);
      if (response.data) {
        const locationDataList: any = [
          { id: 0, label: 'Select Location', locationType: 'all' }, // Default option
          ...response.data.locations.map((item: any) => ({
            id: item.locationRefId + '-' + item.locationType,
            label: item.locationName,
            locationType: item.locationType,
          })),
        ];
        setLocationList(
          locationDataList.sort((a: any, b: any) =>
            a.label.localeCompare(b.label)
          )
        );
        setFilterList(
          locationDataList.sort((a: any, b: any) =>
            a.label.localeCompare(b.label)
          )
        );
        setCurrentSelection('');
        return true;
      } else {
        setFilterList([]);
        return false;
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      return false;
    }
  };
  const fetchDestinations = async () => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL + Constants.inventoryURL}/locations/destination`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        { search: '', limit: -1, offset: 0, isActive: true }
      );
      //console.log(response);
      if (response.data) {
        const locationDataList: any = [
          { id: 0, label: 'Select Destination' }, // Default option
          ...response.data.locations.map((item: any) => ({
            id:
              item.destinationLocationRefId +
              '-' +
              item.destinationLocationType,
            label: item.destinationLocationName,
            locationType: item.destinationLocationType,
          })),
        ];
        setDestinationList(
          locationDataList.sort((a: any, b: any) =>
            a.label.localeCompare(b.label)
          )
        );
        return true;
      } else {
        setDestinationList([]);
        return false;
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      return false;
    }
  };
  const getLocation = (id: any, type: string) => {
    const locationFound =
      type === 'source'
        ? locationList.findIndex((item) => item.id === id)
        : destinationList.findIndex((item) => item.id === id);
    //(locationFound);
    if (locationFound !== -1) {
      //  console.log(locationList[locationFound], '------------');
      return type === 'source'
        ? locationList[locationFound]
        : destinationList[locationFound];
    } else {
      return null;
    }
  };
  const getLocationAndType = (locationData: any) => {
    const locationArr = locationData.split('-');
    if (locationArr.length > 1) {
      return { location: locationArr[0], type: locationArr[1] };
    } else {
      return { location: locationArr[0], type: '' };
    }
  };
  const fetchInventory = async (location: any = null) => {
    try {
      const searchQueries: any = {
        search: searchQuery,
        limit: paginate.limit,
        offset: paginate.offset,

        filter: currentSelection,
      };
      if (currentLocation) {
        const locationData = getLocationAndType(currentLocation);
        searchQueries['locationRefId'] = locationData.location;
        searchQueries['filter'] = locationData.type;
      }
      if (location) {
        const locationData = getLocationAndType(location);
        searchQueries['locationRefId'] = locationData.location;
        searchQueries['filter'] = locationData.type;
      }
      const response = await HttpService.get(
        `${Constants.apiURL + Constants.inventoryURL}/items`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        searchQueries
      );
      //console.log(response);
      if (response.data) {
        setRows(response.data.paginateRecords);
        setTotalRecords(response.data.total);
        handleOrderBy('id');
        return true;
      } else {
        setRows([]);
        setTotalRecords(0);
        return false;
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      return false;
    }
  };

  const fetchBundleData = async () => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL + Constants.refBundleURL}/fetchInventoryReasons`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        null
      );
      //console.log(response);
      if (response.data) {
        setReasonsList(response.data);
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const handlePagination = (paginationData: any) => setPaginate(paginationData);
  const handleCheckBoxChange = (checkId: any) => setCurrentChecked(checkId);
  const handleStatus = (row: any) => {
    let status = '1';
    if (row.status === '1') {
      status = '0';
    }
    if (row.status === '0') {
      status = '1';
    }
    StatusUpdate({ id: row.id, status: status });
  };

  const StatusUpdate = async (dataObj: StatusRequestData) => {
    try {
      console.log('GET Response:');
    } catch (error: any) {}
  };
  const handleAdjustSave = async () => {
    try {
      setSaveInProgress(true);
      const adjustData = {
        adjust: {
          inventoryItemLocationId: form.inventoryItemLocationId.value,
          adjustmentType: 'adjustment',
          itemQuantity: form.itemQuantity.value,
          reasonId: form.reasonId.value,
          transactionNote: form.transactionNote.value,
        },
      };
      const endpoint = `${Constants.apiURL + Constants.inventoryURL}/items/${currentRecord.resourceId}/adjust`;
      const response = await HttpService.post(endpoint, adjustData, {
        headers: { Authorization: `Bearer ${getAdmin()}` },
      });
      if (response.success) {
        setAlert({
          type: 'success',
          message: 'Saved Successfully',
          open: true,
        });
        clearForm();
        fetchInventory();
      }
      setSaveInProgress(false);
    } catch (error: any) {
      setAlert({
        type: 'error',
        message: error.message ? error.message : 'Transaction failed',
        open: true,
      });
      setSaveInProgress(false);
    }
  };
  const adjustFormFields: FormFieldData[] = [
    {
      name: 'inventoryItemLocationId',
      label: 'Location',
      value: form.inventoryItemLocationId.value,
      onChange: handleInputChange,
      isRequired: form.inventoryItemLocationId.required,
      size: 12,
      type: 'selectField',
      options: adjustLocationList,
      validationRules: [(value) => (!value ? 'Location  is required' : '')],
    },
    {
      name: 'itemQuantity',
      label: 'Adjusted Quantity',
      value: form.itemQuantity.value,
      onChange: (e: React.ChangeEvent<any>) => {
        const raw = String(e.target.value ?? '');
        const isNegative = raw.startsWith('-');
        const digits = raw.replace(/\D/g, '');
        const cleaned =
          digits === ''
            ? isNegative
              ? '-'
              : ''
            : (isNegative ? '-' : '') + digits;
        handleInputChange({
          ...e,
          target: { ...e.target, name: 'itemQuantity', value: cleaned },
        });
      },
      isRequired: form.itemQuantity.required,
      size: 12,
      type: 'textfield',
      validationRules: [
        (value) =>
          !value && value !== 0 ? 'Adjusted  Quantity is required' : '',
      ],
    },
    {
      name: 'reasonId',
      label: 'Reason',
      value: form.reasonId.value,
      onChange: handleInputChange,
      isRequired: form.reasonId.required,
      size: 12,
      type: 'selectField',
      options: reasonsList,
      validationRules: [(value) => (!value ? 'Reason  is required' : '')],
    },
    {
      name: 'transactionNote',
      label: 'Transaction Note',
      value: form.transactionNote.value,
      onChange: handleInputChange,
      isRequired: false,
      size: 12,
      type: 'textareaField',
    },
  ];
  const clearForm = () => {
    setForm({
      inventoryItemLocationId: { required: true, value: '' },
      adjustmentType: { required: false, value: 'adjustment' },
      itemQuantity: { required: true, value: '' },
      reasonId: { required: true, value: '' },
      transactionNote: { required: false, value: '' },
    });
    setCurrentRecord(null);
    setAdjustDialogViewOpen(false);
  };
  const AdjustDialogView = () => {
    return (
      <Box sx={{ width: '600px' }}>
        <CommonForm
          fields={adjustFormFields}
          onCancel={() => {
            clearForm();
          }}
          formReset={() => {
            clearForm();
          }}
          formTitle={'Edit / Adjust item'}
          isLoading={saveInProgress}
          isUpdate={true}
          onSave={handleAdjustSave}
          actionButtonPosition="bottom"
          singlePage={true}
        />
      </Box>
    );
  };
  const clearTransfer = () => {
    setAlert({ type: 'success', message: 'Saved Successfully', open: true });
    window.location.reload();
  };
  const handleTransfer = async (type: any) => {
    try {
      const items: any[] = transferList
        .filter((item: any) => item.quantityOrdered > 0)
        .map((item: any) => ({
          resourceId: item.resourceId,
          quantityOrdered: item.quantityOrdered,
          isQuotedItem: false,
        }));

      if (items.length === 0 || items.includes(undefined)) {
        setAlert({
          type: 'error',
          message: 'at least one quantity is required',
          open: true,
        });
        return false;
      }
      if (currentDestination === 0 || currentLocation === 0) {
        setAlert({
          type: 'error',
          message: 'Destination and Source both are required field',
          open: true,
        });
        return false;
      }
      const srcLocation = getLocationAndType(currentLocation);
      const destLocation = getLocationAndType(currentDestination);
      const today = new Date();
      const formattedDate = today.toISOString().split('T')[0];
      const postData = {
        locationRefId: srcLocation.location,
        locationType: srcLocation.type,
        destinationLocationRefId: destLocation.location,
        destinationLocationType: destLocation.type,
        orderDate: formattedDate,
        orderCategory: 'transfer',
        orderStatus: type,
        items: items,
      };
      setSaveInProgress(true);
      const endpoint = `${Constants.apiURL + Constants.inventoryURL}/orders`;
      const response = await HttpService.post(endpoint, postData, {
        headers: { Authorization: `Bearer ${getAdmin()}` },
      });
      if (response.success) {
        clearTransfer();
      }
      setSaveInProgress(false);
    } catch (error: any) {
      setSaveInProgress(false);
    }
  };
  const dialogConfirmation = () => {
    return (
      <Box sx={{ width: '450px' }}>
        <h2>Are you sure you want to transfer items to another Warehouse?</h2>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '20px',
          }}
        >
          <ButtonComponent
            errors={[]}
            keyName="okbuttonconfirm"
            label={'Confirm'}
            onClick={async () => {
              handleTransfer('pending');
              // setTransferDialogViewOpen(false);
              setConfirmDailogOpen(false);
            }}
          />
        </Box>
      </Box>
    );
  };
  const transferDialogView = () => {
    return (
      <Box sx={{ width: '600px' }}>
        <Grid container spacing={2}>
          <Grid size={5}>
            <h3 className="ovreview-label">Source</h3>
            <h2 style={{ fontWeight: 'normal', fontSize: '18px' }}>
              {getLocation(currentLocation, 'source').label}
            </h2>
          </Grid>

          <Grid size={7}>
            <h3 className="ovreview-label">{'Destination'}</h3>
            <SelectFieldComponent
              errorStr=""
              isRequired={false}
              keyName={'destsource'}
              label=""
              name={'destsource'}
              value={currentDestination}
              items={destinationList}
              onChange={(e: any) => {
                setCurrentDestination(e.target.value);
              }}
            />
          </Grid>
        </Grid>

        <Typography variant="h6" sx={{ m: 1 }}>
          Resource Items
        </Typography>
        <NoActionTable
          rows={transferList}
          columns={transferColumns}
          handleRowClick={(row: any) => {}}
          handleStatus={() => {}}
        />
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            alignItems: 'flex-end',
            justifyContent: 'end',
            m: 2,
          }}
        >
          <ButtonComponent
            onClick={() => {
              //  setTransferDialogViewOpen(false);
              setConfirmDailogOpen(true);
            }}
            label={saveInProgress ? 'Saving...' : 'Submit'}
          />
          <ButtonComponent
            onClick={() => {
              //  setTransferDialogViewOpen(false);
              handleTransfer('draft');
            }}
            label={saveInProgress ? 'Saving...' : 'Save'}
          />
        </Box>
      </Box>
    );
  };
  const handleCurrentSelection = (type: string) => {
    if (currentSelection !== type) {
      setCurrentSelection(type);
      setCurrentLocation(0);
      const filteredData = locationList.filter((item: any) => {
        return item.locationType === type;
      });
      setFilterList([
        { id: 0, label: 'Select Location', locationType: 'all' },
        ...filteredData,
      ]);
      return;
    }
    if (currentSelection === currentSelection) {
      setCurrentLocation(0);
      setCurrentSelection('');
      setFilterList(locationList);
      return;
    }
  };
  const handleMainLocationFilter = (id: any) => {
    setCurrentLocation(id);
    fetchInventory(id);
    setDestinationList(destinationList.filter((item) => item.id !== id));
  };
  return (
    <Stack>
      <Box id="main" className="main dashboardmain">
        <section className="section dashboard">
          <div className="containergrid">
            <Typography variant="h6" sx={{ m: 2 }}>
              Warehouse & Onsite Inventory
            </Typography>
            <Paper sx={{ width: '100%' }} className="mt-4">
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '10px',
                  mb: 2,
                }}
              >
                <Typography variant="h6">All Items</Typography>
                <ButtonComponent
                  disabled={currentChecked.length === 0}
                  onClick={() => {
                    //   console.log(currentChecked);
                    const filteredRecords = rows
                      .filter((record) =>
                        currentChecked.includes(record.resourceId)
                      )
                      .map((record) => ({
                        ...record, //
                        quantityOrdered: '',
                      }));
                    setTransferList(filteredRecords);
                    setTransferDialogViewOpen(true);
                  }}
                  keyName="quoteaddicon"
                  label="Transfer"
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: '',
                  alignItems: 'baseline',
                  padding: '10px',
                  height: '70px',
                  gap: 2,
                }}
              >
                <Typography>Filter</Typography>
                <Button
                  variant="outlined"
                  className={
                    currentSelection === 'warehouse' ? 'isActiveBtn' : ''
                  }
                  onClick={() => {
                    handleCurrentSelection('warehouse');
                  }}
                >
                  Warehouse
                </Button>
                <Button
                  variant="outlined"
                  className={currentSelection === 'onsite' ? 'isActiveBtn' : ''}
                  onClick={() => {
                    handleCurrentSelection('onsite');
                  }}
                >
                  Onsite
                </Button>

                {filterList.length > 0 && (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: '',
                      alignItems: 'baseline',
                      height: '70px',
                      gap: 2,
                    }}
                  >
                    <Typography>Choose</Typography>
                    <Box sx={{ width: '280px' }}>
                      <SelectFieldComponent
                        label=""
                        items={filterList}
                        onChange={(e: any) => {
                          //console.log(e);
                          handleMainLocationFilter(e.target.value);
                        }}
                        isRequired={false}
                        name="filterdrp"
                        value={currentLocation}
                        errorStr=""
                        keyName="filterdrp"
                      />
                    </Box>
                  </Box>
                )}
              </Box>
              <CustomPaginationActionsTable
                rows={rows}
                columns={columns}
                totalRecords={totalRecords}
                moreOpen={moreOpen}
                isMore={true}
                handlePagination={handlePagination}
                handleRowClick={(row: any) => {}}
                handleStatus={handleStatus}
                handleCheckBoxChange={handleCheckBoxChange}
                currentLocation={currentLocation}
                paginationModel={{
                  page: paginate.offset,
                  pageSize: paginate.limit,
                }}
                order={order}
                orderBy={orderBy}
                handleOrderBy={handleOrderBy}
              />
            </Paper>
          </div>
        </section>
      </Box>
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
      <SimpleDialogComponent
        title={''}
        dialogContent={AdjustDialogView()}
        open={adjustDialogViewOpen}
        handleClose={() => {
          clearForm();
        }}
      />
      {currentLocation !== 0 && (
        <SimpleDialogComponent
          title={'Transfer item'}
          dialogContent={transferDialogView()}
          open={transferDialogViewOpen}
          handleClose={() => {
            setTransferDialogViewOpen(false);
          }}
        />
      )}
      {
        <SimpleDialogComponent
          title={'Confirmation'}
          dialogContent={dialogConfirmation()}
          open={confirmDailogOpen}
          handleClose={() => {
            setConfirmDailogOpen(false);
          }}
        />
      }
    </Stack>
  );
};

export default WareHouseOnSite;
